export const translations = {
  en: {
    title: "Debate Moderator",
    participantName: "Participant Name",
    initialTime: "Initial Time (minutes)",
    addParticipant: "Add Participant",
    roundTime: "Round Time",
    totalUsed: "Total Used Time",
    timeLeft: "Time Left",
    penalties: "Penalties",
    active: "Active",
    paused: "Paused",
    reset: "Reset",
    remove: "Remove",
    globalTime: "Global Time",
    activeTimer: "Active Timer",
    noActiveParticipant: "Pause",
    chatTitle: "Talk Title",
    round: "Round",
    newRound: "New Round",
    resetAll: "Reset All",
    showStats: "Show Stats",
    enterFullscreen: "Full screen",
    exitFullscreen: "Exit full screen",
    moreOptions: "More",
    roundSettings: "Round settings",
    configuredTime: "Base time",
    roundSettingsHelp: "Adjust the round number and the base time used for all participants.",
    activeSpeaker: "Active speaker",
    toggleLanguage: "Switch language",
    newRoundShort: "Next",
    changeTime: "Change Time",
    minutes: "Minutes",
    seconds: "Seconds",
    editParticipant: "Edit Participant",
    name: "Name",
    time: "Time",
    save: "Save",
    close: "Close",
    statsTitle: "Session Stats",
    participant: "Interventions",
    resetConfirmTitle: "Reset Confirmation",
    resetConfirmMessage: "What would you like to reset?",
    resetGame: "Reset Game",
    resetGameDescription: "Reset only game data (rounds, times, penalties)",
    resetAllDescription: "Reset everything (including participants and title)",
    deleteConfirmTitle: "Delete Participant",
    deleteConfirmMessage: "Are you sure you want to delete this participant?",
    resetTimeConfirmTitle: "Reset Time",
    resetTimeConfirmMessage: "Are you sure you want to reset this participant's time?",
    cancel: "Cancel",
    confirm: "Confirm",
    points: "points",
    score: "Score",
    increasePoints: "Increase score",
    decreasePoints: "Decrease score",
    manageCriteria: "Manage Criteria",
    addNewCriterion: "Add New Criterion",
    criterionName: "Criterion name",
    existingCriteria: "Existing Criteria",
    noCriteria: "No criteria defined",
    showCriteria: "Show Criteria",
    hideCriteria: "Hide Criteria",
    applyingTo: "Applying to",
    noActiveTarget: "No active participant",
    bonuses: "Bonuses",
    penaltiesLabel: "Penalties",
    bonus: "Bonus",
    penalty: "Penalty",
    apply: "Apply",
    addCriterion: "Add Criterion",
    editCriterion: "Edit",
    deleteCriterion: "Delete",
    rulesTitle: "Official Rules",
    showRules: "Rules",
    fallacies: "Fallacies",
    landed: "Landed",
    detected: "Detected",
    detectedBy: "Detected by",
    selectDetectorHint: "Choose who identified it before applying the penalty.",
    needAnotherParticipant: "You need another participant to register a detection.",
    recentFallacyActions: "Recent fallacy actions",
    undo: "Undo",
    fallacyAgainst: "Against",
    landedHistory: "landed it on the active speaker",
    detectedHistory: "detected it against",
    searchFallacy: "Search fallacy...",
    addFallacy: "Add Fallacy",
    fallacyName: "Fallacy name",
    otherCriteria: "Other Criteria"
  },
  es: {
    title: "Moderador de Debate",
    participantName: "Nombre del Participante",
    initialTime: "Tiempo Inicial (minutos)",
    addParticipant: "Añadir Participante",
    roundTime: "Tiempo de Ronda",
    totalUsed: "Tiempo Total Usado",
    timeLeft: "Tiempo Restante",
    penalties: "Penalizaciones",
    active: "Activo",
    paused: "Pausado",
    reset: "Reiniciar",
    remove: "Eliminar",
    globalTime: "Tiempo Global",
    activeTimer: "Temporizador Activo",
    noActiveParticipant: "Pausa",
    chatTitle: "Título de la Charla",
    round: "Ronda",
    newRound: "Nueva Ronda",
    resetAll: "Reiniciar Todo",
    showStats: "Ver Estadísticas",
    enterFullscreen: "Pantalla completa",
    exitFullscreen: "Salir de pantalla completa",
    moreOptions: "Más",
    roundSettings: "Configuración de ronda",
    configuredTime: "Tiempo base",
    roundSettingsHelp: "Ajusta la ronda y el tiempo base que usarán todos los participantes.",
    activeSpeaker: "Participante activo",
    toggleLanguage: "Cambiar idioma",
    newRoundShort: "Nueva",
    changeTime: "Cambiar Tiempo",
    minutes: "Minutos",
    seconds: "Segundos",
    editParticipant: "Editar Participante",
    name: "Nombre",
    time: "Tiempo",
    save: "Guardar",
    close: "Cerrar",
    statsTitle: "Estadísticas de Sesión",
    participant: "Intervenciones",
    resetConfirmTitle: "Confirmar Reinicio",
    resetConfirmMessage: "¿Qué desea reiniciar?",
    resetGame: "Reiniciar Partida",
    resetGameDescription: "Reiniciar solo datos de juego (rondas, tiempos, penalizaciones)",
    resetAllDescription: "Reiniciar todo (incluyendo participantes y título)",
    deleteConfirmTitle: "Eliminar Participante",
    deleteConfirmMessage: "¿Estás seguro que deseas eliminar este participante?",
    resetTimeConfirmTitle: "Reiniciar Tiempo",
    resetTimeConfirmMessage: "¿Estás seguro que deseas reiniciar el tiempo de este participante?",
    cancel: "Cancelar",
    confirm: "Confirmar",
    points: "puntos",
    score: "Puntaje",
    increasePoints: "Subir puntaje",
    decreasePoints: "Bajar puntaje",
    manageCriteria: "Gestionar Criterios",
    addNewCriterion: "Añadir Nuevo Criterio",
    criterionName: "Nombre del criterio",
    existingCriteria: "Criterios Existentes",
    noCriteria: "No hay criterios definidos",
    showCriteria: "Mostrar Criterios",
    hideCriteria: "Ocultar Criterios",
    applyingTo: "Aplicando a",
    noActiveTarget: "Sin participante activo",
    bonuses: "Bonificaciones",
    penaltiesLabel: "Penalizaciones",
    bonus: "Bonificación",
    penalty: "Penalización",
    apply: "Aplicar",
    addCriterion: "Añadir Criterio",
    editCriterion: "Editar",
    deleteCriterion: "Eliminar",
    rulesTitle: "Reglamento Oficial",
    showRules: "Reglas",
    fallacies: "Falacias",
    landed: "Atinada",
    detected: "Detectada",
    detectedBy: "Detectada por",
    selectDetectorHint: "Elige quién la detectó antes de aplicar la penalización.",
    needAnotherParticipant: "Necesitas otro participante para registrar una detección.",
    recentFallacyActions: "Acciones recientes de falacias",
    undo: "Deshacer",
    fallacyAgainst: "Contra",
    landedHistory: "la acertó al participante activo",
    detectedHistory: "la detectó contra",
    searchFallacy: "Buscar falacia...",
    addFallacy: "Añadir Falacia",
    fallacyName: "Nombre de la falacia",
    otherCriteria: "Otros Criterios"
  }
}